module.exports = __webpack_public_path__ + "assets/img/s3_chart-2.7d2186ad.png";